<template>
	<div class="Anexo2_desenhos">

		<h1>DESENHOS</h1>

		<!-- 11_anexo-II_d01-d02.html -->
		<div id="g-11_anexo-II_d01-d02-box" class="ai2html">
			<div id="g-11_anexo-II_d01-d02-Artboard_22" class="g-artboard g-artboard-v4" data-min-width='960'>
				<img id="g-11_anexo-II_d01-d02-Artboard_22-img" class="g-aiImg" :src="caminho + '11_anexo-II_d01-d02-Artboard_22.png'"/>
				<div id="g-ai0-1" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:1.5834%;margin-top:-11.9px;left:0%;width:472px;">
					<p class="g-pstyle0" style="letter-spacing: -.5px">Desenho 1 &ndash; Área livre interna descoberta quando H &le; 10&thinsp;m</p>
				</div>
				<div id="g-ai0-2" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:1.5834%;margin-top:-11.9px;left:52.2982%;width:473px;">
					<p class="g-pstyle0" style="letter-spacing: -.5px">Desenho 2 &ndash; Área livre interna descoberta quando H > 10&thinsp;m</p>
				</div>
				<div id="g-ai0-3" class="g-texto g-aiAbs g-aiPointText" style="top:39.4272%;margin-top:-5.1px;left:76.1584%;margin-left:-18.5px;width:37px;">
					<p class="g-pstyle1">3A</p>
				</div>
				<div id="g-ai0-4" class="g-texto g-aiAbs g-aiPointText" style="top:51.1979%;margin-top:-44.3px;left:6.064%;margin-left:-64px;width:128px;">
					<p class="g-pstyle2" style="letter-spacing:-0.03em;">LARGURA MÍNIMA<br>
					1,50m<br>
					<br>
					ÁREA MÍNIMA</p>
				</div>
				<div id="g-ai0-5" class="g-texto g-aiAbs g-aiPointText" style="top:51.9514%;margin-top:-15.5px;left:76.1502%;margin-left:-80.5px;width:auto;">
					<p class="g-pstyle2" style="background-color:#FFFFFF; height: unset !important;">ÁREA LIVRE<br>INTERNA DESCOBERTA</p>
				</div>
				<div id="g-ai0-6" class="g-texto g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 59.8093687134783%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 59.8093687134783%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 59.8093687134783%;top:52.0336%;margin-top:-5.1px;left:63.7174%;margin-left:-18.5px;width:37px;">
					<p class="g-pstyle1">2A</p>
				</div>
			</div>
		</div>

		<hr>

		<h3>Desenho 3 – Aeração e insolação da edificação (em planta)</h3>
		<!-- 11_anexo-II_d03.html -->
		<div id="g-11_anexo-II_d03-box" class="ai2html">
			<div id="g-11_anexo-II_d03-Artboard_22_copy" class="g-artboard g-artboard-v4" data-min-width='529'>
				<img id="g-11_anexo-II_d03-Artboard_22_copy-img" class="g-aiImg" :src="caminho + '11_anexo-II_d03-Artboard_22_copy.png'"/>
				<div id="g-ai0-1" class="g-texto g-aiAbs g-aiPointText" style="top:1.1207%;margin-top:-8.1px;left:46.6952%;margin-left:-21px;width:42px;">
					<p class="g-pstyle0">760</p>
				</div>
				<div id="g-ai0-2" class="g-texto g-aiAbs g-aiPointText" style="top:1.1207%;margin-top:-8.1px;left:69.4676%;margin-left:-21px;width:42px;">
					<p class="g-pstyle0">758</p>
				</div>
				<div id="g-ai0-3" class="g-texto g-aiAbs g-aiPointText" style="top:9.1738%;margin-top:-8.1px;left:96.2062%;width:42px;">
					<p class="g-pstyle1">756</p>
				</div>
				<div id="g-ai0-4" class="g-texto g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 56.1746261456826%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 56.1746261456826%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 56.1746261456826%;top:14.7005%;margin-top:-8.1px;left:46.8558%;margin-left:-22.5px;width:45px;">
					<p class="g-pstyle0">&ldquo;A1&rdquo;</p>
				</div>
				<div id="g-ai0-5" class="g-texto g-aiAbs" style="top:13.2639%;left:72.1783%;width:15.3119%;">
					<p>Cota mais </p>
					<p>restritiva </p>
					<p>em relação à </p>
					<p>fachada &ldquo;A1&rdquo;</p>
				</div>
				<div id="g-ai0-6" class="g-texto g-aiAbs g-aiPointText" style="top:14.5425%;margin-top:-8.1px;left:96.2062%;width:42px;">
					<p class="g-pstyle1">754</p>
				</div>
				<div id="g-ai0-7" class="g-texto g-aiAbs g-aiPointText" style="top:40.5966%;margin-top:-8.1px;left:15.8122%;margin-left:-22.5px;width:45px;">
					<p class="g-pstyle0">&ldquo;A2&rdquo;</p>
				</div>
				<div id="g-ai0-8" class="g-texto g-aiAbs g-aiPointText" style="top:40.5966%;margin-top:-8.1px;left:80.4355%;margin-left:-22.5px;width:45px;">
					<p class="g-pstyle0">&ldquo;A3&rdquo;</p>
				</div>
				<div id="g-ai0-9" class="g-texto g-aiAbs g-aiPointText" style="top:43.2809%;margin-top:-8.1px;left:96.2062%;width:42px;">
					<p class="g-pstyle1">752</p>
				</div>
				<div id="g-ai0-10" class="g-texto g-aiAbs g-aiPointText" style="top:51.4919%;margin-top:-8.1px;left:96.2062%;width:42px;">
					<p class="g-pstyle1">750</p>
				</div>
				<div id="g-ai0-11" class="g-texto g-aiAbs" style="top:51.1608%;left:11.1456%;width:15.3119%;">
					<p>Cota mais </p>
					<p>restritiva </p>
					<p>em relação à </p>
					<p>fachada &ldquo;A2&rdquo;</p>
				</div>
				<div id="g-ai0-12" class="g-texto g-aiAbs" style="top:51.1608%;left:72.1783%;width:15.3119%;">
					<p>Cota mais </p>
					<p>restritiva </p>
					<p>em relação à </p>
					<p>fachada &ldquo;A3&rdquo;</p>
				</div>
				<div id="g-ai0-13" class="g-texto g-aiAbs g-aiPointText" style="top:89.2308%;margin-top:-8.1px;left:48.0633%;margin-left:-23.5px;width:47px;">
					<p class="g-pstyle0">RUA</p>
				</div>
			</div>
		</div>
		<p><strong>Notas:</strong><br />
		“A1”, “A2”, “A3” = (H − 6) ÷ 10<br />
		H = cota de nível do perfil mais restritivo até o topo da edificação.</p>

		<hr>

		<h3>Desenho 4 – Aeração e insolação pelo espaço do logradouro</h3>
		<!-- 11_anexo-II_d04.html -->
		<div id="g-11_anexo-II_d04-box" class="ai2html">
			<div id="g-11_anexo-II_d04-Artboard_22" class="g-artboard g-artboard-v4" data-min-width='530'>
				<img id="g-11_anexo-II_d04-Artboard_22-img" class="g-aiImg" :src="caminho + '11_anexo-II_d04-Artboard_22.png'"/>
				<div id="g-ai0-1" class="g-texto g-aiAbs g-aiPointText" style="top:1.1163%;margin-top:-8.1px;left:69.3429%;margin-left:-21px;width:42px;">
					<p class="g-pstyle0">758</p>
				</div>
				<div id="g-ai0-2" class="g-texto g-aiAbs g-aiPointText" style="top:1.2735%;margin-top:-8.1px;left:46.6072%;margin-left:-21px;width:42px;">
					<p class="g-pstyle0">760</p>
				</div>
				<div id="g-ai0-3" class="g-texto g-aiAbs g-aiPointText" style="top:9.4522%;margin-top:-8.1px;left:98.1988%;margin-left:-21px;width:42px;">
					<p class="g-pstyle0">756</p>
				</div>
				<div id="g-ai0-4" class="g-texto g-aiAbs g-aiPointText" style="top:14.4853%;margin-top:-8.1px;left:98.1988%;margin-left:-21px;width:42px;">
					<p class="g-pstyle0">754</p>
				</div>
				<div id="g-ai0-5" class="g-texto g-aiAbs g-aiPointText" style="top:43.7399%;margin-top:-8.1px;left:98.1988%;margin-left:-21px;width:42px;">
					<p class="g-pstyle0">752</p>
				</div>
				<div id="g-ai0-6" class="g-texto g-aiAbs g-aiPointText" style="top:51.604%;margin-top:-8.1px;left:98.1988%;margin-left:-21px;width:42px;">
					<p class="g-pstyle0">750</p>
				</div>
				<div id="g-ai0-7" class="g-texto g-aiAbs g-aiPointText" style="top:55.1586%;margin-top:-29.7px;left:72.2583%;width:85px;">
					<p class="g-pstyle1">Cota mais </p>
					<p class="g-pstyle1">restritiva </p>
					<p class="g-pstyle1">em relação </p>
					<p class="g-pstyle1">à frente</p>
				</div>
				<div id="g-ai0-8" class="g-texto g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 56.1746261456826%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 56.1746261456826%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 56.1746261456826%;top:74.8819%;margin-top:-8.1px;left:46.6661%;margin-left:-19px;width:38px;">
					<p class="g-pstyle0">&ldquo;A&rdquo;</p>
				</div>
				<div id="g-ai0-9" class="g-texto g-aiAbs g-aiPointText" style="top:81.1732%;margin-top:-8.1px;left:6.0931%;width:47px;">
					<p class="g-pstyle1">RUA</p>
				</div>
				<div id="g-ai0-10" class="g-texto g-aiAbs g-aiPointText" style="top:88.0936%;margin-top:-8.1px;right:9.8041%;width:162px;">
					<p class="g-pstyle2">EIXO DO LOGRADOURO</p>
				</div>
			</div>
		</div>
		<p><strong>Notas:</strong><br>
		“A” = (H − 4) ÷ 10<br>
		H = cota de nível do perfil mais restritivo até o topo da edificação.</p>

		<hr>

		<h3>Desenho 5 – Aeração e insolação da edificação sem embasamento (em corte)</h3>
		<!-- 11_anexo-II_d05.html -->
		<div id="g-11_anexo-II_d05-box" class="ai2html">
			<div id="g-11_anexo-II_d05-Artboard_22" class="g-artboard g-artboard-v4" data-min-width='455'>
				<img id="g-11_anexo-II_d05-Artboard_22-img" class="g-aiImg" :src="caminho + '11_anexo-II_d05-Artboard_22.png'"/>
				<div id="g-ai0-1" class="g-texto g-aiAbs g-aiPointText" style="top:1.3869%;margin-top:-8.1px;left:20.5284%;margin-left:-22.5px;width:45px;">
					<p class="g-pstyle0">&ldquo;A3&rdquo;</p>
				</div>
				<div id="g-ai0-2" class="g-texto g-aiAbs g-aiPointText" style="top:1.3869%;margin-top:-8.1px;left:68.7861%;margin-left:-22.5px;width:45px;">
					<p class="g-pstyle0">&ldquo;A2&rdquo;</p>
				</div>
				<div id="g-ai0-3" class="g-texto g-aiAbs g-aiPointText" style="top:25.4237%;margin-top:-8.1px;left:78.1209%;margin-left:-22.5px;width:45px;">
					<p class="g-pstyle0">&ldquo;A1&rdquo;</p>
				</div>
				<div id="g-ai0-4" class="g-texto g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 56.1746261456826%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 56.1746261456826%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 56.1746261456826%;top:41.0575%;margin-top:-8.1px;left:97.9202%;margin-left:-22.5px;width:45px;">
					<p class="g-pstyle0">&ldquo;H2&rdquo;</p>
				</div>
				<div id="g-ai0-5" class="g-texto g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 56.1746261456826%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 56.1746261456826%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 56.1746261456826%;top:45.3567%;margin-top:-8.1px;left:1.5234%;margin-left:-22.5px;width:45px;">
					<p class="g-pstyle0">&ldquo;H3&rdquo;</p>
				</div>
				<div id="g-ai0-6" class="g-texto g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 56.1753708840912%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 56.1753708840912%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 56.1753708840912%;top:52.978%;margin-top:-8.1px;left:89.7834%;margin-left:-22.5px;width:45px;">
					<p class="g-pstyle0">&ldquo;H1&rdquo;</p>
				</div>
				<div id="g-ai0-7" class="g-texto g-aiAbs g-aiPointText" style="top:76.2787%;margin-top:-8.3px;right:24.2961%;width:56px;">
					<p class="g-pstyle1">NÍVEL</p>
				</div>
				<div id="g-ai0-8" class="g-texto g-aiAbs g-aiPointText" style="top:80.5715%;margin-top:-15.3px;left:9.7019%;width:79px;">
					<p class="g-pstyle2">MURO DE</p>
					<p class="g-pstyle2">DIVISA</p>
				</div>
				<div id="g-ai0-9" class="g-texto g-aiAbs g-aiPointText" style="top:84.8772%;margin-top:-8.3px;right:64.4187%;width:56px;">
					<p class="g-pstyle1">NÍVEL</p>
				</div>
				<div id="g-ai0-10" class="g-texto g-aiAbs g-aiPointText" style="top:86.8249%;margin-top:-15.3px;right:13.0447%;width:79px;">
					<p class="g-pstyle1">MURO DE</p>
					<p class="g-pstyle1">DIVISA</p>
				</div>
				<div id="g-ai0-11" class="g-texto g-aiAbs g-aiPointText" style="top:97.1822%;margin-top:-15.3px;left:3.1424%;width:122px;">
					<p class="g-pstyle2">PERFIL NATURAL</p>
					<p class="g-pstyle2">DO TERRENO</p>
				</div>
			</div>
		</div>

		<hr>

		<h3>Desenho 6 – Aeração e insolação entre blocos isolados sem embasamento (em planta)</h3>
		<!-- 11_anexo-II_d06.html -->
		<div id="g-11_anexo-II_d06-box" class="ai2html">
			<div id="g-11_anexo-II_d06-Artboard_22" class="g-artboard g-artboard-v4" data-min-width='709'>
				<img id="g-11_anexo-II_d06-Artboard_22-img" class="g-aiImg" :src="caminho + '11_anexo-II_d06-Artboard_22.png'"/>
				<div id="g-ai0-1" class="g-desenho3 g-aiAbs g-aiPointText" style="top:1.1163%;margin-top:-8.1px;left:51.836%;margin-left:-21px;width:42px;">
					<p class="g-pstyle0">758</p>
				</div>
				<div id="g-ai0-2" class="g-desenho3 g-aiAbs g-aiPointText" style="top:1.2736%;margin-top:-8.1px;left:34.8403%;margin-left:-21px;width:42px;">
					<p class="g-pstyle0">760</p>
				</div>
				<div id="g-ai0-3" class="g-desenho3 g-aiAbs g-aiPointText" style="top:4.7337%;margin-top:-8.1px;left:98.5688%;margin-left:-21px;width:42px;">
					<p class="g-pstyle0">756</p>
				</div>
				<div id="g-ai0-4" class="g-desenho3 g-aiAbs g-aiPointText" style="top:16.53%;margin-top:-8.1px;left:98.5688%;margin-left:-21px;width:42px;">
					<p class="g-pstyle0">754</p>
				</div>
				<div id="g-ai0-5" class="g-desenho3 g-aiAbs g-aiPointText" style="top:40.7515%;margin-top:-8.1px;left:43.4558%;margin-left:-22.5px;width:45px;">
					<p class="g-pstyle0">&ldquo;A1&rdquo;</p>
				</div>
				<div id="g-ai0-6" class="g-desenho3 g-aiAbs g-aiPointText" style="top:40.7515%;margin-top:-8.1px;left:54.4889%;margin-left:-22.5px;width:45px;">
					<p class="g-pstyle0">&ldquo;A2&rdquo;</p>
				</div>
				<div id="g-ai0-7" class="g-desenho3 g-aiAbs g-aiPointText" style="top:41.5379%;margin-top:-8.1px;left:98.5688%;margin-left:-21px;width:42px;">
					<p class="g-pstyle0">752</p>
				</div>
				<div id="g-ai0-8" class="g-desenho3 g-aiAbs g-aiPointText" style="top:55.945%;margin-top:-29.7px;left:38.5961%;width:91px;">
					<p class="g-pstyle1">Cota mais</p>
					<p class="g-pstyle1">restritiva em </p>
					<p class="g-pstyle1">relação à </p>
					<p class="g-pstyle1">fachada &ldquo;A2&rdquo;</p>
				</div>
				<div id="g-ai0-9" class="g-desenho3 g-aiAbs g-aiPointText" style="top:55.945%;margin-top:-29.7px;left:49.6642%;width:91px;">
					<p class="g-pstyle1">Cota mais</p>
					<p class="g-pstyle1">restritiva em </p>
					<p class="g-pstyle1">relação à </p>
					<p class="g-pstyle1">fachada &ldquo;A1&rdquo;</p>
				</div>
				<div id="g-ai0-10" class="g-desenho3 g-aiAbs g-aiPointText" style="top:57.5807%;margin-top:-8.1px;left:98.5688%;margin-left:-21px;width:42px;">
					<p class="g-pstyle0">750</p>
				</div>
				<div id="g-ai0-11" class="g-desenho3 g-aiAbs g-aiPointText" style="top:81.1731%;margin-top:-8.1px;left:4.5218%;width:47px;">
					<p class="g-pstyle1">RUA</p>
				</div>
			</div>
		</div>
		<p><strong>Notas:</strong><br>
		“A1”, “A2” = (H − 6) ÷ 10<br>
		H = cota de nível do perfil mais restritivo até o topo da edificação.</p>

		<hr>

		<h3>Desenho 7 – Aeração e insolação entre blocos com embasamento (em corte)</h3>
		<!-- 11_anexo-II_d07.html -->
		<div id="g-11_anexo-II_d07-box" class="ai2html">
			<div id="g-11_anexo-II_d07-Artboard_22" class="g-artboard g-artboard-v4" data-min-width='662'>
				<img id="g-11_anexo-II_d07-Artboard_22-img" class="g-aiImg" :src="caminho + '11_anexo-II_d07-Artboard_22.png'"/>
				<div id="g-ai0-1" class="g-texto g-aiAbs g-aiPointText" style="top:1.219%;margin-top:-8.3px;right:28.0219%;width:56px;">
					<p class="g-pstyle0">NÍVEL</p>
				</div>
				<div id="g-ai0-2" class="g-texto g-aiAbs g-aiPointText" style="top:22.3394%;margin-top:-8.3px;right:66.3716%;width:56px;">
					<p class="g-pstyle0">NÍVEL</p>
				</div>
				<div id="g-ai0-3" class="g-texto g-aiAbs g-aiPointText" style="top:31.78%;margin-top:-8.1px;left:43.3406%;margin-left:-22.5px;width:45px;">
					<p class="g-pstyle1">&ldquo;A1&rdquo;</p>
				</div>
				<div id="g-ai0-4" class="g-texto g-aiAbs g-aiPointText" style="top:31.78%;margin-top:-8.1px;left:52.9139%;margin-left:-22.5px;width:45px;">
					<p class="g-pstyle1">&ldquo;A2&rdquo;</p>
				</div>
				<div id="g-ai0-5" class="g-texto g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 56.1746261456826%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 56.1746261456826%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 56.1746261456826%;top:41.7582%;margin-top:-8.1px;left:84.634%;margin-left:-22.5px;width:45px;">
					<p class="g-pstyle1">&ldquo;H2&rdquo;</p>
				</div>
				<div id="g-ai0-6" class="g-texto g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 56.1746261456826%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 56.1746261456826%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 56.1746261456826%;top:52.2353%;margin-top:-8.1px;left:14.2354%;margin-left:-22.5px;width:45px;">
					<p class="g-pstyle1">&ldquo;H1&rdquo;</p>
				</div>
				<div id="g-ai0-7" class="g-texto g-aiAbs g-aiPointText" style="top:75.0574%;margin-top:-8.3px;right:47.7066%;width:56px;">
					<p class="g-pstyle0">NÍVEL</p>
				</div>
				<div id="g-ai0-8" class="g-texto g-aiAbs g-aiPointText" style="top:85.0301%;margin-top:-15.3px;left:0.6798%;width:79px;">
					<p class="g-pstyle2">MURO DE</p>
					<p class="g-pstyle2">DIVISA</p>
				</div>
				<div id="g-ai0-9" class="g-texto g-aiAbs g-aiPointText" style="top:85.0301%;margin-top:-15.3px;right:0.6104%;width:79px;">
					<p class="g-pstyle0">MURO DE</p>
					<p class="g-pstyle0">DIVISA</p>
				</div>
				<div id="g-ai0-10" class="g-texto g-aiAbs g-aiPointText" style="top:97.669%;margin-top:-15.3px;left:0.6798%;width:122px;">
					<p class="g-pstyle2">PERFIL NATURAL</p>
					<p class="g-pstyle2">DO TERRENO</p>
				</div>
			</div>
		</div>

		<hr>

		<h3>Desenho 8 – Doação de Calçadas</h3>
		<!-- 11_anexo-II_d08.html -->
		<div id="g-11_anexo-II_d08-box" class="ai2html">
			<div id="g-11_anexo-II_d08-Artboard_22" class="g-artboard g-artboard-v4" data-min-width='485'>
				<img id="g-11_anexo-II_d08-Artboard_22-img" class="g-aiImg" :src="caminho + '11_anexo-II_d08-Artboard_22.png'"/>
				<div id="g-ai0-1" class="g-texto g-aiAbs g-aiPointText" style="top:45.9408%;margin-top:-8.1px;left:22.7734%;width:143px;">
					<p class="g-pstyle0">CANTO CHANFRADO</p>
				</div>
				<div id="g-ai0-2" class="g-texto g-aiAbs g-aiPointText" style="transform: matrix(0.6171,0.7869,-0.7869,0.6171,0,0);transform-origin: 50% 56.1753708840912%;-webkit-transform: matrix(0.6171,0.7869,-0.7869,0.6171,0,0);-webkit-transform-origin: 50% 56.1753708840912%;-ms-transform: matrix(0.6171,0.7869,-0.7869,0.6171,0,0);-ms-transform-origin: 50% 56.1753708840912%;top:59.6347%;margin-top:-8.1px;left:13.0425%;margin-left:-24.5px;width:49px;">
					<p class="g-pstyle1">3,5m</p>
				</div>
				<div id="g-ai0-3" class="g-texto g-aiAbs g-aiPointText" style="top:62.0515%;margin-top:-8.1px;left:72.0616%;width:250px; font-size:11px;">
					NOVO ALINHAMENTO
				</div>
				<div id="g-ai0-4" class="g-texto g-aiAbs g-aiPointText" style="top:66.616%;margin-top:-8.1px;left:72.0577%;width:250px; font-size:11px;">
					ANTIGO ALINHAMENTO
				</div>
				<div id="g-ai0-5" class="g-texto g-aiAbs g-aiPointText" style="top:87.2911%;margin-top:-8.1px;left:6.5114%;width:318px;">
					<p class="g-pstyle0">Formato base do lote após doação (conforme escritura)</p>
				</div>
				<div id="g-ai0-6" class="g-texto g-aiAbs g-aiPointText" style="top:96.7514%;margin-top:-8.3px;left:6.5017%;width:114px;">
					<p class="g-pstyle0">Área a ser doada</p>
				</div>
			</div>
		</div>

		<hr>

		<h3>Desenho 9 – Concordância fixada por melhoramento público</h3>
		<!-- 11_anexo-II_d09.html -->
		<div id="g-11_anexo-II_d09-box" class="ai2html">
			<div id="g-11_anexo-II_d09-Artboard_22" class="g-artboard g-artboard-v4" data-min-width='483'>
				<img id="g-11_anexo-II_d09-Artboard_22-img" class="g-aiImg" :src="caminho + '11_anexo-II_d09-Artboard_22.png'"/>
				<div id="g-ai0-1" class="g-texto g-aiAbs g-aiPointText" style="top:52.1165%;margin-top:-8.1px;left:15.2479%;margin-left:-15.5px;width:31px;">
					<p class="g-pstyle0">R</p>
				</div>
				<div id="g-ai0-2" class="g-texto g-aiAbs g-aiPointText" style="top:61.5144%;margin-top:-8.1px;left:9.4574%;margin-left:-15.5px;width:31px;">
					<p class="g-pstyle0">R</p>
				</div>
				<div id="g-ai0-3" class="g-texto g-aiAbs g-aiPointText" style="top:62.0513%;margin-top:-8.1px;left:72.0235%;width:250px; font-size:11px;">
					NOVO ALINHAMENTO
				</div>
				<div id="g-ai0-4" class="g-texto g-aiAbs g-aiPointText" style="top:66.616%;margin-top:-8.1px;left:72.0197%;width:250px; font-size:11px;">
					ANTIGO ALINHAMENTO
				</div>
				<div id="g-ai0-5" class="g-texto g-aiAbs g-aiPointText" style="top:87.2911%;margin-top:-8.1px;left:6.5383%;width:318px;">
					<p class="g-pstyle1">Formato base do lote após doação (conforme escritura)</p>
				</div>
				<div id="g-ai0-6" class="g-texto g-aiAbs g-aiPointText" style="top:96.7514%;margin-top:-8.3px;left:6.5286%;width:114px;">
					<p class="g-pstyle1">Área a ser doada</p>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
export default{
  name: "Anexo2_desenhos", 
		props:['caminho'],
  data(){
	return{
		title: "Anexo 2 - Desenhos",

	}
  }
}
</script>

<style lang="scss">
@import '../assets/main.scss';

/* 11_anexo-II_d01-d02.html */
#g-11_anexo-II_d01-d02-box .g-artboard {
	margin:0;
}
#g-11_anexo-II_d01-d02-box .g-artboard p {
	margin:0;
}
.g-aiAbs {
	position:absolute;
}
.g-aiImg {
	display:block;
	width:100% !important;
}
.g-aiPointText p { white-space: nowrap; }
#g-11_anexo-II_d01-d02-Artboard_22 {
	position:relative;
	overflow:hidden;
	width:960px;
}
#g-11_anexo-II_d01-d02-Artboard_22 p {
	/*font-family:'Museo',arial,helvetica,sans-serif;*/
	font-weight:bold;
	font-size:16px;
	line-height:19px;
	height:auto;
	filter:alpha(opacity=100);
	-ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
	opacity:1;
	letter-spacing:0em;
	text-align:left;
	color:rgb(0,0,0);
	text-transform:none;
	padding-bottom:0;
	padding-top:0;
	mix-blend-mode:normal;
	font-style:normal;
}
#g-11_anexo-II_d01-d02-Artboard_22 .g-pstyle0 {
	height:19px;
}
#g-11_anexo-II_d01-d02-Artboard_22 .g-pstyle1 {
	font-size:12px;
	line-height:8px;
	height:8px;
	letter-spacing:0.01em;
	text-align:center;
}
#g-11_anexo-II_d01-d02-Artboard_22 .g-pstyle2 {
	font-size:12px;
	line-height:14px;
	height:14px;
	letter-spacing:0.01em;
	text-align:center;
}

/* 11_anexo-II_d03.html */
#g-11_anexo-II_d03-box .g-artboard {
	margin:0;
}
#g-11_anexo-II_d03-box .g-artboard p {
	margin:0;
}
.g-aiAbs {
	position:absolute;
}
.g-aiImg {
	display:block;
	width:100% !important;
}
.g-aiPointText p { white-space: nowrap; }
#g-11_anexo-II_d03-Artboard_22_copy {
	position:relative;
	overflow:hidden;
	width:529px;
}
#g-11_anexo-II_d03-Artboard_22_copy p {
	/*font-family:'Museo',arial,helvetica,sans-serif;*/
	font-size:12px;
	line-height:14px;
	filter:alpha(opacity=100);
	-ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
	opacity:1;
	letter-spacing:0em;
	text-align:left;
	color:rgb(0,0,0);
	text-transform:none;
	padding-bottom:0;
	padding-top:0;
	mix-blend-mode:normal;
	font-style:normal;
	height:auto;
}
#g-11_anexo-II_d03-Artboard_22_copy .g-pstyle0 {
	height:14px;
	text-align:center;
}
#g-11_anexo-II_d03-Artboard_22_copy .g-pstyle1 {
	height:14px;
}

/* 11_anexo-II_d04.html */
#g-11_anexo-II_d04-box .g-artboard {
	margin:0;
}
#g-11_anexo-II_d04-box .g-artboard p {
	margin:0;
}
.g-aiAbs {
	position:absolute;
}
.g-aiImg {
	display:block;
	width:100% !important;
}
.g-aiPointText p { white-space: nowrap; }
#g-11_anexo-II_d04-Artboard_22 {
	position:relative;
	overflow:hidden;
	width:530px;
}
#g-11_anexo-II_d04-Artboard_22 p {
	/*font-family:'Museo',arial,helvetica,sans-serif;*/
	font-size:12px;
	line-height:14px;
	height:auto;
	filter:alpha(opacity=100);
	-ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
	opacity:1;
	letter-spacing:0em;
	text-align:left;
	color:rgb(0,0,0);
	text-transform:none;
	padding-bottom:0;
	padding-top:0;
	mix-blend-mode:normal;
	font-style:normal;
}
#g-11_anexo-II_d04-Artboard_22 .g-pstyle0 {
	height:14px;
	text-align:center;
}
#g-11_anexo-II_d04-Artboard_22 .g-pstyle1 {
	height:14px;
}
#g-11_anexo-II_d04-Artboard_22 .g-pstyle2 {
	height:14px;
	text-align:right;
}

/* 11_anexo-II_d05.html */
#g-11_anexo-II_d05-box .g-artboard {
	margin:0;
}
#g-11_anexo-II_d05-box .g-artboard p {
	margin:0;
}
.g-aiAbs {
	position:absolute;
}
.g-aiImg {
	display:block;
	width:100% !important;
}
.g-aiPointText p { white-space: nowrap; }
#g-11_anexo-II_d05-Artboard_22 {
	position:relative;
	overflow:hidden;
	width:455px;
}
#g-11_anexo-II_d05-Artboard_22 p {
	/*font-family:'Museo',arial,helvetica,sans-serif;*/
	font-size:12px;
	line-height:14px;
	height:auto;
	filter:alpha(opacity=100);
	-ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
	opacity:1;
	letter-spacing:0em;
	text-align:left;
	color:rgb(0,0,0);
	text-transform:none;
	padding-bottom:0;
	padding-top:0;
	mix-blend-mode:normal;
	font-style:normal;
}
#g-11_anexo-II_d05-Artboard_22 .g-pstyle0 {
	height:14px;
	text-align:center;
}
#g-11_anexo-II_d05-Artboard_22 .g-pstyle1 {
	height:14px;
	text-align:right;
}
#g-11_anexo-II_d05-Artboard_22 .g-pstyle2 {
	height:14px;
}

/* 11_anexo-II_d06.html */
#g-11_anexo-II_d06-box .g-artboard {
	margin:0;
}
#g-11_anexo-II_d06-box .g-artboard p {
	margin:0;
}
.g-aiAbs {
	position:absolute;
}
.g-aiImg {
	display:block;
	width:100% !important;
}
.g-aiPointText p { white-space: nowrap; }
#g-11_anexo-II_d06-Artboard_22 {
	position:relative;
	overflow:hidden;
	width:709px;
}
#g-11_anexo-II_d06-Artboard_22 p {
	/*font-family:'Museo',arial,helvetica,sans-serif;*/
	font-size:12px;
	line-height:14px;
	height:auto;
	filter:alpha(opacity=100);
	-ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
	opacity:1;
	letter-spacing:0em;
	text-align:left;
	color:rgb(0,0,0);
	text-transform:none;
	padding-bottom:0;
	padding-top:0;
	mix-blend-mode:normal;
	font-style:normal;
}
#g-11_anexo-II_d06-Artboard_22 .g-pstyle0 {
	height:14px;
	text-align:center;
}
#g-11_anexo-II_d06-Artboard_22 .g-pstyle1 {
	height:14px;
}

/* 11_anexo-II_d07.html */
#g-11_anexo-II_d07-box .g-artboard {
	margin:0;
}
#g-11_anexo-II_d07-box .g-artboard p {
	margin:0;
}
.g-aiAbs {
	position:absolute;
}
.g-aiImg {
	display:block;
	width:100% !important;
}
.g-aiPointText p { white-space: nowrap; }
#g-11_anexo-II_d07-Artboard_22 {
	position:relative;
	overflow:hidden;
	width:662px;
}
#g-11_anexo-II_d07-Artboard_22 p {
	/*font-family:'Museo',arial,helvetica,sans-serif;*/
	font-size:12px;
	line-height:14px;
	height:auto;
	filter:alpha(opacity=100);
	-ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
	opacity:1;
	letter-spacing:0em;
	text-align:left;
	color:rgb(0,0,0);
	text-transform:none;
	padding-bottom:0;
	padding-top:0;
	mix-blend-mode:normal;
	font-style:normal;
}
#g-11_anexo-II_d07-Artboard_22 .g-pstyle0 {
	height:14px;
	text-align:right;
}
#g-11_anexo-II_d07-Artboard_22 .g-pstyle1 {
	height:14px;
	text-align:center;
}
#g-11_anexo-II_d07-Artboard_22 .g-pstyle2 {
	height:14px;
}

/* 11_anexo-II_d08.html */
#g-11_anexo-II_d08-box .g-artboard {
	margin:0;
}
#g-11_anexo-II_d08-box .g-artboard p {
	margin:0;
}
.g-aiAbs {
	position:absolute;
}
.g-aiImg {
	display:block;
	width:100% !important;
}
.g-aiPointText p { white-space: nowrap; }
#g-11_anexo-II_d08-Artboard_22 {
	position:relative;
	overflow:hidden;
	width:485px;
}
#g-11_anexo-II_d08-Artboard_22 p {
	/*font-family:'Museo',arial,helvetica,sans-serif;*/
	font-size:12px;
	line-height:14px;
	height:auto;
	filter:alpha(opacity=100);
	-ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
	opacity:1;
	letter-spacing:0em;
	text-align:left;
	color:rgb(0,0,0);
	text-transform:none;
	padding-bottom:0;
	padding-top:0;
	mix-blend-mode:normal;
	font-style:normal;
}
#g-11_anexo-II_d08-Artboard_22 .g-pstyle0 {
	height:14px;
}
#g-11_anexo-II_d08-Artboard_22 .g-pstyle1 {
	height:14px;
	text-align:center;
}

/* 11_anexo-II_d09.html */
#g-11_anexo-II_d09-box .g-artboard {
	margin:0;
}
#g-11_anexo-II_d09-box .g-artboard p {
	margin:0;
}
.g-aiAbs {
	position:absolute;
}
.g-aiImg {
	display:block;
	width:100% !important;
}
.g-aiPointText p { white-space: nowrap; }
#g-11_anexo-II_d09-Artboard_22 {
	position:relative;
	overflow:hidden;
	width:483px;
}
#g-11_anexo-II_d09-Artboard_22 p {
	/*font-family:'Museo',arial,helvetica,sans-serif;*/
	font-size:12px;
	line-height:14px;
	height:auto;
	filter:alpha(opacity=100);
	-ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
	opacity:1;
	letter-spacing:0em;
	text-align:left;
	color:rgb(0,0,0);
	text-transform:none;
	padding-bottom:0;
	padding-top:0;
	mix-blend-mode:normal;
	font-style:normal;
}
#g-11_anexo-II_d09-Artboard_22 .g-pstyle0 {
	height:14px;
	text-align:center;
}
#g-11_anexo-II_d09-Artboard_22 .g-pstyle1 {
	height:14px;
}
</style>


// WEBPACK FOOTER //
// src/components/Anexo2_desenhos.vue